import { Input } from "antd";
import { useTranslation } from "react-i18next";
import { BiChevronLeft } from "react-icons/bi";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import { NAME_SPACES } from "shared/locales/constants";

const StepDetails = ({ name, onNameChange, onBack, onSave, loading }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const DETAILS = t("DETAILS", { returnObjects: true });

  return (
    <Card type="simple">
      <div className="pricers-import__card-header">
        <div>
          <h3 className="pricers-import__card-title">{DETAILS.TITLE}</h3>
          <p className="pricers-import__card-description">
            {DETAILS.DESCRIPTION}
          </p>
        </div>
        <Button type="primary--outlined" onClick={onBack}>
          <BiChevronLeft size={18} />
          {DETAILS.BACK}
        </Button>
      </div>

      <div className="pricers-import__card-body">
        <div className="dynamic-documents__details-form">
          <div className="m-bottom-16">
            <label className="input__label">{DETAILS.NAME}</label>
            <Input
              placeholder={DETAILS.NAME_PLACEHOLDER}
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              className="dynamic-documents__field-full"
            />
          </div>
        </div>
      </div>

      <div className="pricers-import__card-actions">
        <Button
          type="primary"
          onClick={onSave}
          loading={loading}
          disabled={!name?.trim()}
        >
          {DETAILS.SAVE}
        </Button>
      </div>
    </Card>
  );
};

export default StepDetails;
